import { Add, History } from "@material-ui/icons";
import { Box, Fab, Stack, Tooltip, Typography } from "@mui/material";

const TableToolbar = ({ toolbar }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      p={2}
      bgcolor={({ palette }) => palette.grey[50]}>
      <Box flex="1">
        {toolbar.title && (
          <Typography fontSize={20} fontWeight={500} component="h6">
            {toolbar.title}
          </Typography>
        )}
      </Box>
      <Box>
        {toolbar.onCreate && (
          <Fab
            color="primary"
            aria-label="add"
            size="small"
            onClick={toolbar.onCreate}>
            <Add />
          </Fab>
        )}
        {toolbar.onViewHistories && (
          <Tooltip title="Xem lịch sử xuất file">
            <Fab
              color="primary"
              aria-label="history"
              size="small"
              onClick={toolbar.onViewHistories}>
              <History />
            </Fab>
          </Tooltip>
        )}
      </Box>
    </Stack>
  );
};

export default TableToolbar;
